
import { post, get } from '@/utils/request';

export const login = (data, config = {}) => post('login/shopLogin', data, config);

export const loginCheck = data => post('login/loginCheck', data);

export const logout = (data) => post('login/shopLogOut', data);

// 获取用户id
export const getUserId = () => get('/user/getUserId');
